let heroSwiper;

document.addEventListener("DOMContentLoaded", function () {
  heroSwiper = new Swiper(".hero-slide-wrapper", {
      direction: "vertical",
      effect: "fade",
      loop: true,
      autoplay: {
        delay: slideSpeed,
      },
      autoHeight: false,
      height: 960,
      on:{
        //Used to fix a weird bug where the second slide doesn't play the animation on the first loop only -N.T-
        beforeSlideChangeStart: (swiper) => {swiper.slides[swiper.activeIndex].classList.add("force-animation")},
        slideChangeTransitionEnd: (swiper) => {swiper.slides[swiper.activeIndex].classList.add("force-animation")}
      }
    });
});